// LogRocket and Sentry only report from the real production site. A production build
// served anywhere else (localhost, `serve dist`, a preview deploy, a test run) has
// APP_ENV=production too, so the build environment alone isn't enough.
const PRODUCTION_HOST = 'platform.drawbotics.com';


export function isProductionHost(hostname = window.location.hostname) {
  return hostname === PRODUCTION_HOST;
}


export const REPORTING_ENABLED = process.env.APP_ENV === 'production' && isProductionHost();
